module.exports = __webpack_public_path__ + "static/img/t_h_menu.7366b5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/t_h_menu.png
// module id = lcdh
// module chunks = 1